var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBigCreditcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.66,23.21l-8.62-8.62-1.41-.59H11l-1.41,.59L.96,23.21l-.59,1.41v51.75l.59,1.41,8.62,8.62,1.41,.59H88.62l1.41-.59,8.62-8.62,.59-1.41V24.62l-.59-1.41ZM11.83,18H87.8l7.45,7.45v7.8H4.38v-7.8l7.45-7.45ZM87.8,83H11.83l-7.45-7.45v-29.36H95.25v29.36l-7.45,7.45ZM15.31,63.44h25.88v8.62H15.31v-8.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigCreditcard);
export default __webpack_public_path__ + "static/1779176049/media/icon-big-creditcard.004cb44955ab96360a688cf45b9f5df0.svg";
export { ForwardRef as ReactComponent };